import { stringify } from 'qs';
import request from '@/utils/request';

// 获取portal下的登陆log记录
export async function qryLoginLogs(params) {
  return request(`/logs/login/self?${stringify(params)}`);
}

export async function queryUsersMsg() {
  return request('/users/current');
}
export async function queryPortalMsg(params) {
  return request(`/users/${params}/portals`);
}
export async function modifyProfile(params) {
  return request('/users/self', {
    method: 'PATCH',
    body: params,
  });
}
export async function currentUser() {
  return request('/users/current');
}
